import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';
import { Text16 } from 'atoms/typography';
import arrow from 'components/collections/assets/arrow.svg';

const Wrapper = styled(Horizontal).attrs({ gap: 0.5 })``;

const StyledImg = styled.img`
  width: var(--intermediate-unit);
`;

type Props = { bonus: number };

export const Bonus = ({ bonus }: Props) => {
  const { formatNumber } = useIntl();

  return (
    <Wrapper>
      <Text16 bold>
        {formatNumber(bonus * 100, {
          maximumFractionDigits: 1,
          trailingZeroDisplay: 'stripIfInteger',
          signDisplay: 'exceptZero',
        })}
        %
      </Text16>
      <StyledImg alt="" src={arrow} />
    </Wrapper>
  );
};
